var _defs, _linearGradient, _radialGradient, _linearGradient2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAnimatedLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470 225.51",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}\n      .cls-1{stroke-width:17px;}\n      .cls-2{stroke-width:20px;}\n      .cls-3{fill:url(#linear-gradient);}\n      .cls-4{fill:url(#radial-gradient);}\n    "))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 420,
    y1: 108.47,
    x2: 580,
    y2: 108.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0,
    x2: 150,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 513.85,
    y1: 9.26,
    x2: 560.23,
    y2: 9.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "transform1",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-800 0",
    repeatCount: "indefinite",
    dur: "1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#EC008C; #EC008C; black; black",
    keyTimes: "0; 0.333; 0.334; 1",
    begin: "transform1.begin",
    dur: 3,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 504.73,
    y1: 62.26,
    x2: 560.23,
    y2: 62.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "transform2",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-800 0",
    repeatCount: "indefinite",
    begin: "0.55s",
    dur: "0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#00FFC5; #00FFC5; #00FFC5; #00FFC5",
    keyTimes: "0; 0.333; 0.334; 1",
    begin: "transform2.begin",
    dur: 2.1,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 475,
    y1: 100,
    x2: 560.23,
    y2: 100
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-800 0",
    repeatCount: "indefinite",
    begin: "-0.5s",
    dur: "0.8s"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 513.85,
    y1: 215.26,
    x2: 560.23,
    y2: 215.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-800 0",
    repeatCount: "indefinite",
    begin: "-0.25s",
    dur: "0.6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#EC008C; #EC008C; #EC008C; #EC008C",
    keyTimes: "0; 0.333; 0.334; 1",
    begin: "transform2.begin",
    dur: 2.1,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 475,
    y1: 153.26,
    x2: 610.23,
    y2: 153.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "transform3",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-800 0",
    repeatCount: "indefinite",
    begin: "0.4s",
    dur: "0.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#0284C7; #0284C7; #0284C7; #0284C7",
    keyTimes: "0; 0.333; 0.334; 1",
    begin: "transform3.begin",
    dur: 2.7,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 420,
    y: 0.22,
    width: 200,
    height: 225.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 0,
    cy: 100,
    rx: 100,
    ry: 200
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimatedLines);
export default __webpack_public_path__ + "static/media/logo-animated-lines.2cf355e26b9080020eac5c857ba95527.svg";
export { ForwardRef as ReactComponent };